//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const EB1201RequiredFieldsLegend: FeatureFlag = {"Id":"EB1201RequiredFieldsLegend","Label":"(KILL)[10.27]EB1201RequiredFieldsLegend","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch for the fix to EB-1201. When active, a visible 'asterisks indicate required fields' legend is displayed at the top of each form page for all users (sighted and screen reader). When disabled, the legend is rendered as screen-reader-only text (sr-only), preserving the accessibility fix while removing the visual element.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
